import { Hammer } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { FadeUp } from "@/components/site/Motion";
import { AppFeature } from "@/components/site/AppFeature";
import { CtaBand } from "@/components/site/CtaBand";
import { APPS } from "@/lib/content";

export default function Portfolio() {
  return (
    <div data-testid="portfolio-page">
      <PageHero
        testId="portfolio-hero"
        eyebrow="Portfolio"
        lines={["Apps we have made.", <span className="text-[#0D6EFD]">More on the way.</span>]}
        intro="Each app here was imagined, designed and built by Aries App Station. Here is what is out so far."
      />
      <section className="mx-auto max-w-7xl space-y-28 px-5 pb-24 sm:px-8">
        {APPS.map((a, i) => <AppFeature key={a.id} app={a} reverse={i % 2 === 1} />)}
      </section>
      <section className="mx-auto max-w-7xl px-5 sm:px-8">
        <FadeUp>
          <div data-testid="more-in-works" className="relative overflow-hidden rounded-[2rem] bg-[#0A0F1D] p-10 text-white sm:p-14">
            <div className="absolute -right-10 -top-10 h-60 w-60 rounded-full bg-[#0D6EFD]/40 blur-3xl" />
            <span className="relative grid h-14 w-14 place-items-center rounded-2xl bg-white/10"><Hammer className="h-7 w-7" /></span>
            <h2 className="font-display relative mt-8 text-4xl font-extrabold tracking-tight sm:text-5xl">We are working on more.</h2>
            <p className="relative mt-4 max-w-xl text-base text-slate-300 md:text-lg">New apps are in development right now. Check back soon, or get in touch to hear when the next one lands.</p>
            <div className="relative mt-8 flex flex-wrap gap-3">
              {["Next app · in development", "Another idea · in design"].map((t) => (
                <span key={t} className="font-mono rounded-full border border-white/20 px-4 py-1.5 text-xs uppercase tracking-wider text-slate-200">{t}</span>
              ))}
            </div>
          </div>
        </FadeUp>
      </section>
      <CtaBand title="Want early news on our next app?" text="Send us a message and we will let you know." />
    </div>
  );
}
